import {useNavigate, useSearchParams} from "react-router-dom";
import {pipelineSelector, useGetPipelineQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {PipelineProfile} from "../../components/profile/PipelineProfile/PipelineProfile"
import {useTranslation} from "react-i18next";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const PipelineProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const id = params.get("id") ?? undefined;

  const {t} = useTranslation(["common"])

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.pipeline", "Pipeline") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <PipelineProfilePage id={id}/>;
};

export const PipelineProfilePage = (props: Props) => {
  const {id} = props;

  const [access, setAccess] = useState(false);

  const selectPipeline = useMemo(() => {
    return pipelineSelector()
  }, []);

  const {pipeline, isFetching, error} = useGetPipelineQuery(access ? (id ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      pipeline: selectPipeline(result),
      isFetching: result.isFetching,
      error: result.error,
    })
  });

  return (
    <EntityProfilePage
      permissions={["pipeline_view"]}
      entity={pipeline}
      isLoading={isFetching}
      error={error}
      onAccess={setAccess}>
      {(entity) => (
        <PipelineProfile pipeline={entity}/>
      )}
    </EntityProfilePage>
  )
};
